<div [ngClass]="{'hidden-panel': hiddenPanel}">

      <mat-tab-group [@.disabled]="true" tabGroupDrag class="mini-tab" mat-stretch-tabs="false" mat-align-tabs="start" (selectedTabChange)="changeBlockType($event)">
          <mat-tab>
              <ng-template mat-tab-label>
                  <div class="menu-button">
                      <mat-icon>dashboard_customize</mat-icon>
                      {{'general.stickers' | transloco}}
                  </div>
              </ng-template>
          </mat-tab>
          <mat-tab>
              <ng-template mat-tab-label>
                  <div class="menu-button">
                      <mat-icon>star_rate</mat-icon>
                      {{'general.snippets' | transloco}}
                  </div>
              </ng-template>
          </mat-tab>
      </mat-tab-group>

  <div fxLayout="row" fxLayoutAlign="space-between center" class="sticker-buttons">
    @if (addBlockType == 'BLOCK_SNIPPETS') {
      <a mat-icon-button
        class="mini-button"
        [style.color]="color"
        [cpPosition]="'bottom'"
        [cpPositionOffset]="'50%'"
        [cpOutputFormat]="'hex'"
        [cpPositionRelativeToArrow]="true"
        [(colorPicker)]="color"
        (colorPickerChange)="colorPickerChange($event)"
        >
        <mat-icon class="addIcons" matTooltip="{{'general.textColor' | transloco}}">color_lens</mat-icon>
      </a>
    }
    @if (addBlockType == 'BLOCK_STICKERS') {
      <a mat-icon-button class="mini-button" disabled>
        <mat-icon class="addIcons" matTooltip="{{'general.textColor' | transloco}}">color_lens</mat-icon>
      </a>
    }
    <a mat-icon-button class="mini-button" (click)="addStickerLabel('head')">
      <fa-icon [icon]="faHeading" matTooltip="{{'general.addHeader' | transloco}}"></fa-icon>
    </a>
    <a mat-icon-button class="mini-button" (click)="addStickerLabel('title')">
      <mat-icon class="addIcons" matTooltip="{{'general.addTitle' | transloco}}">title</mat-icon>
    </a>
    <a mat-icon-button class="mini-button" (click)="addStickerLabel('label')">
      <fa-icon [icon]="faFont" matTooltip="{{'general.addText' | transloco}}"></fa-icon>
    </a>
    <a mat-icon-button class="mini-button" (click)="toggleBlockSize()">
      <span style="opacity: 0.8;" matTooltip="{{'general.toggleSmallView' | transloco}}">
        @if (!blockSmallView) {
          <svg viewBox="0 0 448 512" class="svg-inline--fa fa-grid-2 fa-lg"><path fill="currentColor"
            d="M192 80c0-26.5-21.5-48-48-48H48C21.5 32 0 53.5 0 80v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80zm0 256c0-26.5-21.5-48-48-48H48c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V336zM256 80v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H304c-26.5 0-48 21.5-48 48zM448 336c0-26.5-21.5-48-48-48H304c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V336z"
          class=""></path></svg>
        }
      </span>
      @if (blockSmallView) {
        <mat-icon matTooltip="{{'general.toggleLargeView' | transloco}}">apps</mat-icon>
      }
    </a>
    @if (stickersAsEmbedded) {
      <a matTooltip="{{'general.stickersAsItem2' | transloco}}" mat-icon-button class="mini-button" (click)="toggleStickersAsEmbedded()">
        <mat-icon>link</mat-icon>
      </a>
    }
    @if (!stickersAsEmbedded) {
      <a matTooltip="{{'general.stickersAsShortcuts2' | transloco}}" mat-icon-button class="mini-button" (click)="toggleStickersAsEmbedded()">
        <mat-icon>link_off</mat-icon>
      </a>
    }
      <app-video-link videoLink="stickersToolbox"></app-video-link>
    <div class="hide-gt-sm">
      <app-scroll-buttons contentId="stickList"></app-scroll-buttons>
    </div>
  </div>
  <div
    class="content-wrapper"
    id="stickList"
    infinite-scroll
    [scrollWindow]="false"
    [infiniteScrollDistance]="scrollDistance"
    [infiniteScrollThrottle]="throttle"
    (scrolled)="loadMoreStickers()">

    <div
      cdkDropList
      cdkDropListSortingDisabled
      fxLayout="row wrap" fxLayoutAlign="center center"
      class="drag-panel dragCursor import-nav-bg"
      [ngClass]="{'small-view': blockSmallView}"
      [cdkDropListData]="currentStickers"
      (cdkDropListDropped)="dropSticker($event)">

      <!-- <cdk-virtual-scroll-viewport itemSize="20">
      <div *cdkVirtualFor="let stickers of chunkedStickers">
        <div cdkDrag class="thumbs" *ngFor="let mini of stickers" [cdkDragData]="mini">
          <mat-icon (click)="addSticker(mini)" class="thumbsHide fade-in-image">control_point</mat-icon>
          <img class="shadow-grow" loading="lazy" [src]="'./assets/stickers/' + mini[0] + '_' + mini[2]['sceneId'] + '.png'">
                        <div *cdkDragPreview class="drag-preview" [ngStyle]="{
                                        'width.px': dragItemSize,
                                        'height.px': dragItemSize
                                    }">
            <img [src]="'./assets/stickers/' + mini[0] + '_' + mini[2]['sceneId'] + '.png'">
          </div>
        </div>
      </div>
    </cdk-virtual-scroll-viewport> -->

    <!-- enable to use ngSrc -->
    <!--            <div cdkDrag class="thumbs" *ngFor="let mini of stickers" [cdkDragData]="mini">-->
    <!--                <mat-icon (click)="addSticker(mini)" class="thumbsHide fade-in-image">control_point</mat-icon>-->
    <!--                <img width="120" height="120" priority class="shadow-grow" [ngSrc]="'./assets/stickers/' + mini[0] + '_' + mini[2]['sceneId'] + '.png'">-->
            <!--                <div *cdkDragPreview class="drag-preview" [ngStyle]="{-->
            <!--                    'width.px': dragItemSize,-->
            <!--                    'height.px': dragItemSize-->
            <!--                }">-->
            <!--                    <img width="{{dragItemSize}}" height="{{dragItemSize}}" priority [ngSrc]="'./assets/stickers/' + mini[0] + '_' + mini[2]['sceneId'] + '.png'">-->
            <!--                </div>-->
            <!--            </div>-->

            @for (mini of currentStickers; track mini) {
<div cdkDrag class="thumbs" [cdkDragData]="mini">
                <mat-icon (click)="addSticker(mini)" class="thumbsHide fade-in-image">control_point</mat-icon>
                <img class="shadow-grow" loading="lazy" [src]="'./assets/stickers/' + mini[0] + '_' + mini[2]['sceneId'] + '.png'">
                <div *cdkDragPreview class="drag-preview" [ngStyle]="{
                                'width.px': dragItemSize,
                                'height.px': dragItemSize
                            }">
      <img [src]="'./assets/stickers/' + mini[0] + '_' + mini[2]['sceneId'] + '.png'">
    </div>
  </div>
}
</div>
</div>
</div>

<ng-template let-modal #downloadModal class="transparentDialog">
  <div mat-dialog-content>
    <br/>
    <br/>
    <br/>
    <div fxLayout="column" fxLayoutAlign="center center">
      <div>
        <app-loading [type]="9" [size]="'40px'"></app-loading>
      </div>
      <div style="margin: 15px;" fxFlex fxLayoutAlign="center center">
        <mat-icon style="margin-right: 10px;">file_download</mat-icon>
        <span>{{ resourceName }}</span>
      </div>
      <button mat-mini-fab color="primary" (click)="onClose()" class="fade-in" style="margin-top: 10px;">
        <mat-icon style="transform: scale(1.2);">close</mat-icon>
      </button>
    </div>
    <br/>
    <br/>
  </div>
</ng-template>
